import { jsonFetch, backendUrl } from "@/data/http"

export type ContactRequestApiDto = {
  firstName: string
  lastName: string
  phoneNumber: string
  email: string
}

export const createContactRequest = (params: ContactRequestApiDto) =>
  jsonFetch<void>(
    `${backendUrl}/v1/contact-requests`,
    { method: "POST", body: JSON.stringify(params) },
  )
